import './RegistrationForm.css'
import React from 'react'

function RegistrationForm({onRegister, errorMessage, error}) {

  const [isValid, setIsValid] = React.useState({});

  const [username, setUserName] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')

  const [errorNameMessage, setErrorNameMessage] = React.useState('')
  const [errorEmailMessage, setErrorEmailMessage] = React.useState('')
  const [errorPasswordMessage, setErrorPasswordMessage] = React.useState('')

  const [errorName, setErrorName] = React.useState(true)
  const [errorEmail, setErrorEmail] = React.useState(true)
  const [errorPassword, setErrorPassword] = React.useState(true)

  function handleSubmit(e) {
    e.preventDefault();
    onRegister({
      password,
      email,
      username
    });
  }
  
  const handleUserNameChange = (e) => {
    const inputText = e.target.value;
    const validInput = /^[\s\S]*$/u.test(inputText);

    if (!inputText.trim()) {
      setErrorNameMessage("Имя не может быть пустым, пожалуйста, введите ваше уникальное имя");
      setErrorName(true);
    } else {
      setErrorNameMessage('');
      setErrorName(false);
      setUserName(inputText);
    }
  }

  const handlePasswordChange = (e) => {
    if (!e.target.value.length) {
      setErrorPasswordMessage("Пароль обязательное поле для заполнения, пожалуйста, заполните пароль");
      setErrorPassword(true);
    } else if (e.target.value.length < 8) {
      setErrorPasswordMessage("Пароль должен быть более 8 символов, содержать цифры и буквы");
      setErrorPassword(true);
    } else {
      setErrorPasswordMessage('');
      setErrorPassword(false);
    }
    setPassword(e.target.value);
  };

  const handleEmailChange = (e) => {
    const validEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      e.target.value
    )

    if (!e.target.value.length) {
      setErrorEmailMessage("Обязательное поле, пожалуйста укажите вашу почту")
      setErrorEmail(true)
    } else if (!validEmail) {
      setErrorEmailMessage("Не валидный имейл, попробуйте еще раз")
      setErrorEmail(true)
    } else {
      setErrorEmailMessage('')
      setErrorEmail(false)
    }
    setEmail(e.target.value)
  }
  

  React.useEffect(() => {
    if (errorName || errorEmail || errorPassword) {
      setIsValid(false)
    } else {
      setIsValid(true)
    }
  }, [errorEmail, errorName, errorPassword])

  return (
    <section className="registration">
        <form className="registration__form" onSubmit={handleSubmit}>
        <h2 className="registration__title">Регистрация</h2>
        <fieldset className='registration__fieldset'>
          <span className='registration__input-span'>User name</span>
            <input
              required
              name="username"
              type="text"
              minLength="2"
              className="registration__input" 
              onChange={handleUserNameChange}
            />  
          {errorName? <span className="contactForm__err-span">{errorNameMessage}</span>:<span></span>}

          <span className="registration__input-span">E-mail</span>
          <input
              required
              autoComplete="on"
              name="email"
              type="email"
              className="registration__input"
              onChange={handleEmailChange}
          ></input>
          
          {errorEmail? <span className="contactForm__err-span">{errorEmailMessage}</span>:<span></span>}
          
          <span className="registration__input-span">Password</span>
          <input
              required
              name="password"
              type="password"
              minLength="8"
              className="registration__input"
              onChange={handlePasswordChange}
          ></input>
          {errorPassword? <span className="contactForm__err-span">{errorPasswordMessage}</span>:<span></span>}
          
          </fieldset>
          <div className="contactForm__btn-container">
            {error? <span className="contactForm__under-btn-err-span">{errorMessage}</span>: <span></span>}
            <button 
              type="submit" 
              disabled={!isValid}
              className={`registration__btn ${isValid && 'registration__btn_active'}`}>
              {'Зарегистрироваться'}
            </button>
          </div>
        </form>
      </section>
  );
}

export default RegistrationForm;